import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

interface Props {
  /** titleコンポーネントで使用 */
  readonly title: string
  /** サイトの概要説明に使用*/
  readonly description: string
  /** その他metaタグをsetする */
  readonly children?: React.ReactNode
}

/**
 * @description
 * GatsbyのuseStaticQuery Reactフックで
 * データを検索するSEOコンポーネント
 *
 * @See {@link https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/}
 */
export const Seo = ({ description, title, children }: Props) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `,
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  const ogpImage = site.siteMetadata?.ogpImage

  return (
    <>
      <title>{defaultTitle ? `${title} | ${defaultTitle}` : title}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta property="og:image" content={ogpImage} />
      {children}
    </>
  )
}
